export default __webpack_public_path__ + "static/media/CityLights09.95519c6b.jpg";